<template>
  <div style="margin-top: 200px">
    <div style="display: flex; justify-content: center">
      <div class="center-flex-top" style="width: 70%; justify-content: left">
        <div class="mylogin" style="margin-bottom: 5px; width: 8%">
          {{ $t("userinfo.我的账户") }}
        </div>
        <div class="myloginName" style="width: 40%">
          <div style="text-align: center">
            {{ $store.state.userInfo.name }}
          </div>
        </div>
        <div
          style="
            width: 40%;
            display: flex;
            justify-content: left;
            margin-left: 50px;
            margin-bottom: 5px;
          "
        >
          <div style="border-radius: 50%">
            <img
              src="@/assets/setting.png"
              width="16px"
              height="16px"
              style="margin-top: -5px"
            />
          </div>
          <a
            href="#"
            @click="settingUserInfo"
            class="myloginName"
            style="margin-left: 5px"
            >{{ $t("userinfo.账户设置") }}</a
          >
        </div>
        <div
          style="
            width: 12%;
            display: flex;
            justify-content: right;
            margin-bottom: 5px;
          "
        >
          <div style="border-radius: 50%">
            <img
              src="@/assets/outlogin.png"
              width="16px"
              height="16px"
              style="margin-top: -5px"
            />
          </div>
          <a
            href="#"
            @click="outLogin"
            class="myloginName"
            style="margin-left: 5px"
            >{{ $t("userinfo.注销") }}</a
          >
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: center">
      <div style="padding: 20px">
        <div
          class="center-flex"
          style="width: 50%; justify-content: right; cursor: pointer"
          @click="favourite"
        >
          <div
            class="image-filter"
            style="
              justify-content: center;
              cursor: pointer;
              align-items: center;
              cursor: hand;
            "
          >
            <img
              width="32px"
              class="image"
              height="32px"
              src="@/assets/shoucangwhite.png"
            />
          </div>
        </div>
        <div class="favourFont" style="margin-left: 15px">收藏</div>
      </div>
      <div style="padding: 20px">
        <div
          class="center-flex"
          style="width: 50%; justify-content: right; cursor: pointer"
          @click="compare"
        >
          <div
            class="image-filter"
            style="
              justify-content: center;
              cursor: pointer;
              align-items: center;
              cursor: hand;
            "
          >
            <img
              width="35px"
              class="image"
              height="35px"
              src="@/assets/tianpinhgwhite.png"
            />
          </div>
        </div>
        <div class="favourFont" style="margin-left: 15px">对比</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {
    settingUserInfo() {
      this.$router.push({ path: "/register", query: { editState: "edit" } });
    },
    outLogin() {
      localStorage.removeItem("userJson");
      this.$store.dispatch("setMessage", {});
      //localStorage.setItem("userJson", {});
      // alert(localStorage.getItem("userJson"));
      // if (localStorage.getItem("userJson") != {}) {
      // alert(localStorage.getItem("userJson"));
      //}
      //alert(Object.keys(this.$store.state.userInfo).length);
      this.$router.push({ path: "/login" });
    },
    favourite() {
      if (this.$store.state.favoriteList.length > 0) {
        this.$router.push({ path: "/favorite" });
      } else {
        this.$notification.error({
          message: "收藏",
          description: "没有加入收藏得叉车!",
        });
      }
    },
    compare() {
      if (this.$store.state.bijiaoList.length > 0) {
        this.$router.push({ path: "/compare" });
      } else {
        this.$notification.error({
          message: "较藏",
          description: "没有加入比较得叉车!",
        });
      }
    },
  },
};
</script>

<style scoped>
.center-flex {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */

  /* height: 100vh; /* 使div的高度为视口高度 */
}
.center-flex-top {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  border-bottom: 1px blue solid;
  /* height: 100vh; /* 使div的高度为视口高度 */
}
.image-filter {
  display: flex;
  background-color: #047bd0;
  border-color: transparent;
  border-radius: 50%;
  width: 125px;
  height: 65px;
  margin-top: 20px;
}
.mylogin {
  justify-content: left;
  font-size: 14px;
  color: #0067b3;
  font-weight: bold;
}
.myloginName {
  justify-content: center;
  font-size: 13px;
  color: #515456;
}
</style>
